<template>
    <ClientOnly>
        <RecaptchaV2
            @load-callback="handleLoadCallback"
            :sitekey="useRuntimeConfig().public.site_key"
            size="comapact"
        />
    </ClientOnly>
</template>

<script setup>
import { RecaptchaV2 } from "vue3-recaptcha-v2";
import { defineEmits } from "vue";
const emit = defineEmits();

const handleLoadCallback = (call) => {
    emit("get-key", call);
};
</script>
